export enum RoleEnum {
  Sales = 'sales',
  Manager = 'manager',
  Admin = 'admin',
  Super = 'super',
  None = 'NONE',
}
